import { LoginDirectLoginFetch } from "AxiosApi/userApi";
import { DotPulse } from "ldrs/react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom"; // 1. ایمپورت کردن useNavigate
// import { loginSuccess } from "./path/to/authSlice";

import "ldrs/react/DotPulse.css";
const ProtectedRoute = ({children}) => {
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const decodedUser = useSelector((state) => state.auth.decodedUser);
    const role = Number(
        decodedUser?.["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]
    );

    const location = useLocation();
    const navigate = useNavigate(); // 2. مقداردهی هوک
    const dispatch = useDispatch();
    const [isVerifying, setIsVerifying] = useState(true);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const verifyToken = params.get("verify_token");

        // اگر توکنی برای بررسی وجود ندارد، کار خاصی نکن
        if (!verifyToken) {
            setIsVerifying(false);
            return;
        }

        // اگر توکن وجود دارد ولی کاربر لاگین نیست، آن را بررسی کن
        if (!isAuthenticated) {
            const verifyUserToken = async () => {
                try {
                    const response = await LoginDirectLoginFetch({ token: verifyToken });
                    if (response.data.isSuccess) {
                        // dispatch(loginSuccess(response.data));
                        console.log("Token verified and user logged in.");
                        
                    }
                } catch (error) {
                    console.error("Error during token verification fetch:", error);
                    setIsVerifying(false);
                } finally {
                    // در هر صورت، فرآیند بررسی تمام شده و باید URL تمیز شود
                    setIsVerifying(false);
                    // 3. ✅ حذف کوئری استرینگ از URL
                    navigate(location.pathname, { replace: true });
                }
            };

            verifyUserToken();
        } else {
            // اگر کاربر از قبل لاگین است، فقط توکن را از URL حذف کن
            setIsVerifying(false);
            navigate(location.pathname, { replace: true });
        }

    }, [location.pathname, location.search, isAuthenticated, dispatch, navigate]);

    if (isVerifying) {
      return <div className=" flex flex-col w-full h-screen items-center justify-center bg-gray-100" >
          <div className=" p-10 bg-white rounded-xl shadow-lg">
            <DotPulse size="43" speed="1.3" color="black" />
          </div>
    </div>; // یا یک کامپوننت لودینگ بهتر
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    if (role === 5) {
        window.location.href = "https://pendartararia.com";
        return null;
    }

    return  children;
};

export default ProtectedRoute;